import confetti from "canvas-confetti";

/** True when the OS/browser asks to minimise animation. */
function prefersReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

/**
 * A short celebratory confetti burst at a viewport-normalised origin
 * (`x`/`y` in 0–1, measured from the top-left); defaults to centre.
 *
 * No-op when the user prefers reduced motion — guarded both by our own check
 * and canvas-confetti's built-in `disableForReducedMotion`.
 */
export function celebrate(origin?: { x: number; y: number }): void {
  if (prefersReducedMotion()) return;
  void confetti({
    particleCount: 90,
    spread: 70,
    startVelocity: 38,
    gravity: 0.9,
    ticks: 200,
    scalar: 0.9,
    origin: origin ?? { x: 0.5, y: 0.5 },
    disableForReducedMotion: true,
  });
}
